<script setup lang="ts">
import { missingConfigKeys } from '../lib/config'

const missing = missingConfigKeys()
</script>

<template>
  <div
    v-if="missing.length > 0"
    class="panel panel--inset stack"
    style="--stack-gap: var(--space-2)"
  >
    <div class="row">
      <span class="badge badge--warn">{{ $t('setup.title') }}</span>
    </div>
    <p class="muted">{{ $t('setup.body') }}</p>
    <ul class="stack config-keys" style="--stack-gap: var(--space-1)">
      <li v-for="key of missing" :key="key" class="mono faint selectable">{{ key }}</li>
    </ul>
    <p class="faint">{{ $t('setup.hint') }}</p>
  </div>
</template>

<style scoped>
.config-keys {
  list-style: none;
  margin: 0;
  padding: 0;
}
</style>
